/** Сообщение backend'а о незаполненном регламенте матча. */
const MISSING_PERIODS_MESSAGE = 'gamePeriodsNumber or periodTime is 0 or null, it must be set in the settings';

/** Сорвалась ли синхронизация из-за пустых «периодов» в регламенте соревнования.
 *
 * Случай стоит отдельно: это не сбой сети, а незаполненная настройка, и оператору надо
 * объяснить, куда идти её заполнять. Причина приезжает по-разному — `syncGameInfo`
 * реджектится строкой (`rejectWithValue(message)`), а прямой вызов маппера бросает `Error`,
 * — поэтому предикат принимает `unknown`. */
export function isMatchPeriodsSettingsMissing(error: unknown): boolean {
  const message = error instanceof Error ? error.message : typeof error === 'string' ? error : '';

  return message.includes(MISSING_PERIODS_MESSAGE);
}
